import React from "react"
import DashboardContent from "./admin/Dashboard"

// Dashboard page component
export const DashboardPage = () => {
  return <DashboardContent />
}
